import React from 'react'
import ReactDOM from 'react-dom'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import App from 'containers/app/App'
import Constants from 'Constants'
import reportWebVitals from './reportWebVitals'

import './index.css'

const { LAUNCH_DARKLY_CLIENT_SIDE_ID } = Constants

// If the SPA is loaded on a vanity/tenant host, ask the backend if the host
// maps to a business. If so, redirect to the URL the backend returns.
// Replaces server-side redirect that used to live in the backend DefaultController.
async function resolveHostAndMaybeRedirect() {
  if (new URLSearchParams(window.location.search).has('bid')) return
  const apiBase = process.env.REACT_APP_PORTAL_API_BASE_URL
  if (!apiBase) return
  try {
    const res = await fetch(
      `${apiBase}/api/v1/portal/resolve-host?host=${encodeURIComponent(window.location.host)}`,
      { credentials: 'omit' }
    )
    if (res.status !== 200) return
    const { redirectUrl } = await res.json()
    if (redirectUrl) window.location.replace(redirectUrl)
  } catch (e) {
    console.warn('resolveHost failed; rendering SPA as-is', e)
  }
}

;(async () => {
  await resolveHostAndMaybeRedirect()
  const LDProvider = await asyncWithLDProvider({ clientSideID: LAUNCH_DARKLY_CLIENT_SIDE_ID })

  ReactDOM.render(
    <React.StrictMode>
      <LDProvider>
        <App />
      </LDProvider>
    </React.StrictMode>,
    document.getElementById('root')
  )
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
